
import { useScrollAnimation, getAnimationClass } from '../../../hooks/useScrollAnimation';

function AnimatedSection({ children, animation = 'slide-up' as 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in', delay = 0, className = '' }: { children: React.ReactNode; animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in'; delay?: number; className?: string }) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div ref={ref} className={`${getAnimationClass(isVisible, animation, delay)} ${className}`}>
      {children}
    </div>
  );
}

export default function Testimonial() {
  const testimonials = [
    {
      quote: 'Anamnesy Soft transformó completamente nuestra clínica. Antes perdíamos horas buscando historiales en papel, ahora todo está a un clic. La gestión de presión intraocular con alertas automáticas nos ha ayudado a detectar glaucomas más temprano.',
      name: 'Dra. Lucía Fernández',
      role: 'Oftalmóloga, Clínica Visual del Sur',
      stars: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20latina%20female%20ophthalmologist%20doctor%20in%20white%20coat%20smiling%20confidently%20portrait%20headshot%20in%20modern%20eye%20clinic%20office%20bright%20clean%20environment%20warm%20lighting%20professional%20photography&width=120&height=120&seq=testimonial-doc-1&orientation=squarish',
    },
    {
      quote: 'La implementación fue increíblemente rápida. En dos días ya estábamos operando al 100%. El módulo de óptica integrado es exactamente lo que necesitábamos para gestionar nuestro inventario de monturas y lentes.',
      name: 'Dr. Eduardo Reyes',
      role: 'Director, Centro Oftalmológico Reyes',
      stars: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20latino%20male%20eye%20doctor%20ophthalmologist%20in%20white%20coat%20with%20stethoscope%20smiling%20portrait%20headshot%20in%20modern%20medical%20office%20bright%20clean%20environment%20professional%20photography&width=120&height=120&seq=testimonial-doc-2&orientation=squarish',
    },
    {
      quote: 'Gestionar tres consultorios era un caos hasta que encontramos Anamnesy Soft. Ahora tengo visibilidad total de todas las sedes, los reportes automáticos me ahorran horas cada semana y mis pacientes reciben recordatorios sin que yo haga nada.',
      name: 'Dra. Camila Torres',
      role: 'Fundadora, Óptica Torres & Asociados',
      stars: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20young%20female%20doctor%20optometrist%20in%20elegant%20white%20coat%20smiling%20warmly%20portrait%20headshot%20modern%20bright%20medical%20office%20background%20clean%20professional%20photography&width=120&height=120&seq=testimonial-doc-3&orientation=squarish',
    },
  ];

  return (
    <section id="testimonios" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection animation="fade-in">
          <div className="text-center mb-14">
            <span className="inline-block text-xs font-semibold text-emerald-600 uppercase tracking-widest mb-3">Testimonios</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Profesionales que confían en <span className="font-display italic text-emerald-600">Anamnesy Soft</span>
            </h2>
            <p className="text-sm text-gray-500 max-w-lg mx-auto">
              Descubre por qué oftalmólogos y clínicas de salud visual eligen nuestra plataforma para su práctica diaria.
            </p>
          </div>
        </AnimatedSection>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <AnimatedSection key={index} animation="slide-up" delay={index * 150}>
              <div className="bg-white p-7 rounded-xl shadow-sm border border-gray-100 hover:shadow-lg transition-all cursor-pointer group h-full">
                <div className="flex items-center space-x-1 mb-5">
                  {Array.from({ length: t.stars }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                  ))}
                </div>
                <blockquote className="text-sm text-gray-700 leading-relaxed mb-6">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
                <div className="flex items-center space-x-3 pt-5 border-t border-gray-100">
                  <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-gray-900">{t.name}</p>
                    <p className="text-xs text-gray-500">{t.role}</p>
                  </div>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
